<template>
  <div>
    <div class="row items-center q-mb-md q-gutter-sm">
      <q-btn-toggle
        v-if="hasTrashed"
        v-model="viewMode"
        toggle-color="primary"
        :options="toggleOptions"
      />

      <q-space />

      <template v-if="viewMode === 'persons'">
        <SearchInput
          :model-value="personKeyword"
          placeholder="Search people..."
          style="width: 200px"
          @update:model-value="personKeyword = $event"
        />

        <q-btn
          :color="mergeMode ? 'negative' : 'grey'"
          :icon="mergeMode ? 'fa fa-times' : 'fa fa-compress-arrows-alt'"
          :label="mergeMode ? 'Cancel' : 'Merge'"
          flat
          @click="mergeMode = !mergeMode"
        />
      </template>
    </div>

    <PersonsView
      v-if="viewMode === 'persons'"
      :client-id="client.id"
      :keyword="personKeyword"
      :merge-mode="mergeMode"
      @merge-complete="mergeMode = false"
    />

    <TrashedPersonsView
      v-if="viewMode === 'trash'"
      :client-id="client.id"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DetailedClient } from '@/type';
import SearchInput from '@/components/SearchInput.vue';
import PersonsView from './PersonsView.vue';
import TrashedPersonsView from './TrashedPersonsView.vue';

export default defineComponent({
  components: {
    SearchInput,
    PersonsView,
    TrashedPersonsView,
  },
  props: {
    client: {
      type: Object as () => DetailedClient,
      required: true,
    },
  },
  data() {
    return {
      viewMode: 'persons' as 'persons' | 'trash',
      personKeyword: '',
      mergeMode: false,
    };
  },
  computed: {
    hasTrashed(): boolean {
      return this.client.totalTrashedPersons > 0;
    },
    toggleOptions(): Array<{ label: string, value: string }> {
      return [
        { label: `Active (${this.client.totalPersons})`, value: 'persons' },
        { label: `Trash (${this.client.totalTrashedPersons})`, value: 'trash' },
      ];
    },
  },
  watch: {
    hasTrashed(val: boolean) {
      if (!val) {
        this.viewMode = 'persons';
      }
    },
  },
});
</script>
